import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AppConfigView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import {
  invalidateAdminAppConfigAudit,
  invalidateAdminAppConfigs,
} from "@/lib/query/core/invalidation";

// Resets a single key to the env-fallback by deleting the DB row.
// Backend returns the post-delete view (source='unset', value=null).
export function useResetAppConfigMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ key }: { key: string }) =>
      apiJsonClient<AppConfigView>(endpoints.admin.appConfigByKey(key), {
        method: "DELETE",
      }),
    onSuccess: async (_data, variables) => {
      await invalidateAdminAppConfigs(queryClient);
      await invalidateAdminAppConfigAudit(queryClient, variables.key);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
